<script>
export default {
    name: "BankPaymentForm",

    props: {
        bankModes: Array,
        bankCOAs: Array,
        payment: Object,
        errors: Array,
        totalAmount: Number
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <div class="md:w-1/4 w-1/2 p-tiny">
            <label for="grid-cash-account" class="label-control">Account:</label>
            <tail-select>
                <template v-slot:field>
                    <select v-model="payment.accountID"
                        id="grid-bank-account" class="input-control input-sm text-xs">
                        <option 
                            v-for="(bankCOA,idx) in bankCOAs" 
                            :key="idx" :value="bankCOA.coaid">{{ bankCOA.coaName }}</option>
                    </select>
                </template>
            </tail-select>
            <p class="form-text-error" 
                v-if="errors.filter(error => error.field == 'accountID').length">
                  {{ errors.filter(error => error.field == 'accountID')[0].message }}</p>
        </div>
        <div class="md:w-1/4 w-1/2 p-tiny">
            <label for="grid-bank-mode" class="label-control">Mode:</label>
            <tail-select>
                <template v-slot:field>
                    <select v-model="payment.paymentModeID"
                        id="grid-bank-mode" class="input-control input-sm text-xs">
                        <option 
                            v-for="(bankMode,idx) in bankModes" 
                            :key="idx" :value="bankMode.pModeID">{{ bankMode.mode }}</option>
                    </select>
                </template>
            </tail-select>
            <p class="form-text-error" 
                v-if="errors.filter(error => error.field == 'paymentModeID').length">
                  {{ errors.filter(error => error.field == 'paymentModeID')[0].message }}</p>
        </div>
        <div class="md:w-1/4 w-1/2 p-tiny">
            <label for="grid-bank-ref" class="label-control">Ref:</label>
            <input type="text" 
                v-model.trim="payment.paymentRef" 
                id="grid-bank-ref" class="input-control input-sm text-xs">
        </div>
        <div class="md:w-1/5 w-1/2 p-tiny">
            <label for="grid-cash-amount" class="label-control">Amount:</label>
            <input type="number" 
                id="grid-cash-amount" :value="totalAmount" disabled 
                class="input-control input-sm text-xs disabled">
            <p class="form-text-error" 
                v-if="errors.filter(error => error.field == 'amount').length">
                  {{ errors.filter(error => error.field == 'amount')[0].message }}</p>
        </div>
    </div>
</template>